import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MutationOptionsAlone } from 'apollo-angular/types';
import { CreateCommentMutation, CreateCommentMutationVariables } from 'graphql.generated';
import { Delta } from 'quill';

import { ActionSource } from 'src/app/state/action-sources';

export const NewOpportunityAddInventoryActions = createActionGroup({
    source: ActionSource.ADD_INVENTORY,
    events: {
        'Add Inventory Contents Changed': props<{ inventoryText: Delta }>(),
        'Add Inventory Button Clicked': emptyProps(),
        'Build Update Inventory Variables Success': props<{
            vars: CreateCommentMutationVariables;
            opts: MutationOptionsAlone<CreateCommentMutation, CreateCommentMutationVariables>;
            changeIds: string[];
        }>(),
        'Update Inventory Success': props<{ changeIds: string[] }>(),
        'Update Inventory Error': props<{ error: Error; changeIds: string[] }>(),
    },
});
